import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TextInputFieldWithValidation from '../ValidationFormElements/TextInputFieldWithValidation';
import TextMaskCustom from '../MUI/TextMaskCustom';
import MainButton from '../MUI/MainButton';

const SearchVehicle = ({
  classes,
  formProps,
  handleSearchVehicle,
  infoBlock,
  disableSearchButton,
  isFetchingEkengVehicleData,
}) => {
  const { t } = useTranslation();

  const { errors, clearError, getValues, setValue, handleSubmit } = formProps;

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid item xs={12} sm={6}>
        <TextInputFieldWithValidation
          required
          formProps={{
            errors,
            clearError,
          }}
          labelKey="transportation.plateNumber"
          name="plateNumber"
          value={getValues().plateNumber ? getValues().plateNumber.toUpperCase() : ''}
          handleChange={(e) => setValue('plateNumber', e.target.value, true)}
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: {
              handler: 'plateNumberMask',
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInputFieldWithValidation
          required
          formProps={{
            errors,
            clearError,
          }}
          labelKey="transportation.passport"
          name="passport"
          value={getValues().passport}
          handleChange={(e) => setValue('passport', e.target.value, true)}
        />
      </Grid>
      {infoBlock && infoBlock}
      <MainButton
        variant="contained"
        color="primary"
        className={classes.submitButton}
        onClick={() => handleSubmit(handleSearchVehicle)()}
        disabled={disableSearchButton}
        loading={isFetchingEkengVehicleData}
      >
        {t('roadCareContract.search')}
      </MainButton>
    </Grid>
  );
};

SearchVehicle.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
    submitButton: PropTypes.string,
  }).isRequired,
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}).isRequired,
    clearError: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  }).isRequired,
  handleSearchVehicle: PropTypes.func.isRequired,
  infoBlock: PropTypes.node.isRequired,
  disableSearchButton: PropTypes.bool.isRequired,
  isFetchingEkengVehicleData: PropTypes.bool.isRequired,
};

export default SearchVehicle;
